module.exports = ".div-contingencia {\n    margin-top: 5px;\n}\n\n.linha {\n    margin: 0px !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal/hostname-modal/hostname-modal.component.css
// module id = ./src/app/modal/hostname-modal/hostname-modal.component.css
// module chunks = main